import { Group, Stack, StackProps, Title } from '@mantine/core';
import { RapidModel } from '@/types/rapidModel';
import { AssetActionColumn } from '../../components/table/columns/assetActionsColumn/AssetActionColumn';
import { rapidModelToAssetRow } from '../../components/table/hooks/useAssetsTable';
import { OptimisticAssetsAction, useOptimisticAssets } from '../../components/table/hooks/useOptimisticAssets';
import { useSelectedAssetContext } from '../../contexts/SelectedAssetContext';
import { AssetName } from '../atoms/AssetName';

interface OutputAssetDetailsHeaderProps extends StackProps {
  asset: RapidModel;
}

export function OutputAssetDetailsHeader({ asset, ...props }: OutputAssetDetailsHeaderProps) {
  const { dispatchAssetAction } = useOptimisticAssets();
  const { setSelectedAsset } = useSelectedAssetContext();

  const handleDelete = (action: OptimisticAssetsAction) => {
    dispatchAssetAction(action);
    setSelectedAsset(undefined);
  };

  return (
    <Stack gap='xs' {...props}>
      <Group justify='space-between' w='100%'>
        <AssetName id={asset.id} name={asset.name} isOutput={true} />
        <AssetActionColumn
          row={{
            original: rapidModelToAssetRow(asset),
            getIsSelected: () => false,
            toggleSelected: () => null,
          }}
          onAssetDelete={handleDelete}
          showShare
        />
      </Group>
    </Stack>
  );
}
